import { render, staticRenderFns } from "./PageCategoryBalance.vue?vue&type=template&id=7bf086a2"
import script from "./PageCategoryBalance.vue?vue&type=script&lang=js"
export * from "./PageCategoryBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports